"use client";

import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { client } from "@/lib/hono";
import toast from "@/lib/toast";
import { t } from "@/lib/localization";

export default function ExportFolderCaptionsDropdownMenuItem({
    folderId,
}: {
    folderId: string;
}) {
    const exportFolder = async () => {
        const res = await client.api.storage.captions.folder[":folderId"].$get({
            param: { folderId },
        });

        if (!res.ok) {
            throw new Error(t("toast.error.export-folder"));
        }

        const { captions } = await res.json();

        // Build plain-text content
        const textContent = captions
            .map(
                (item) =>
                    `${t("storage.export.captions.header.video-name")}: ${
                        item.title ?? ""
                    }\n${t("storage.export.captions.header.captions")}: ${
                        item.captions
                    }\n\n\n\n\n`
            )
            .join("");

        // Trigger download
        const blob = new Blob([textContent], {
            type: "text/plain;charset=utf-8;",
        });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", t("storage.export.captions.filename"));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <DropdownMenuItem
            onClick={(e) => {
                e.stopPropagation();
                toast.promise(
                    exportFolder(),
                    {
                        loading: t("toast.loading.export-folder"),
                        success: t("toast.success.export-folder"),
                        error: t("toast.error.export-folder"),
                    },
                    {
                        loading: {
                            keyName: "toast.loading.export-folder",
                        },
                        success: {
                            keyName: "toast.success.export-folder",
                        },
                        error: {
                            keyName: "toast.error.export-folder",
                        },
                    }
                );
            }}
        >
            {t("storage.folders-grid.item.options.export-captions", undefined, undefined)}
        </DropdownMenuItem>
    );
}
